import { BaseModel } from "../_base.model";
import IStockLocationModel from "./stock-location.model";

export default class WarehouseCartBinModel extends BaseModel implements IStockLocationModel<number> {
    id: number;
    name: string;
    referenceId: number;
    warehouseCartId: number;
}